import React from "react"
import PropTypes from "prop-types"
import styles from "./tabs.module.css"

const Tabs = ({ tabs, activeTab, onTabChange, className = "" }) => {
  return (
    <div className={`${styles.tabHeader} ${className}`}>
      {tabs?.map((tab) => (
        <button
          key={tab.key}
          className={`${styles.tabButton} ${activeTab === tab.key ? styles.tabButtonActive : ""}`}
          onClick={() => onTabChange(tab.key)}
          aria-selected={activeTab === tab.key}
          role="tab"
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default Tabs
